import { render, staticRenderFns } from "./defaultLayout.vue?vue&type=template&id=09d48ad7&scoped=true"
import script from "./defaultLayout.vue?vue&type=script&lang=js"
export * from "./defaultLayout.vue?vue&type=script&lang=js"
import style0 from "./defaultLayout.vue?vue&type=style&index=0&id=09d48ad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d48ad7",
  null
  
)

export default component.exports